import { z } from "zod";
import { ServiceActivityPartyItemSchema } from "./activity-party-item";

export const ServiceActivityItemSchema = z.object({
  id: z.string().uuid(),
  activityTypeCode: z.number(),
  created: z.string().datetime().optional(),
  sortDate: z.string().datetime().optional(),
  stateCode: z.number(),
  regardingObjectId: z.string().uuid().optional(),
  parties: z.array(ServiceActivityPartyItemSchema).optional(),
});

export type ServiceActivityItemType = z.infer<typeof ServiceActivityItemSchema>;

export const ActivityState = {
  OPEN: 0,
  COMPLETED: 1,
  CANCELED: 2,
  SCHEDULED: 3,
} as const;
